import { render, staticRenderFns } from "./UserActionsLog.vue?vue&type=template&id=47b172c2&scoped=true&lang=pug&"
import script from "./UserActionsLog.vue?vue&type=script&lang=js&"
export * from "./UserActionsLog.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsLog.vue?vue&type=style&index=0&id=47b172c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b172c2",
  null
  
)

export default component.exports